<mat-card class="decoration-card">
    <mat-card-content>

        <mat-toolbar *ngIf="!isReadonly">
            <span class="example-spacer"></span>

            <button mat-icon-button matTooltip="add a control system" (click)="create()" *ngIf="!isReadonly">
                <mat-icon>plus_one</mat-icon>
            </button>
        </mat-toolbar>

        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

            <!-- name Column -->
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Name </th>
                <td mat-cell *matCellDef="let element"> {{element.name}} </td>
            </ng-container>

            <!-- maintenance_checked Column -->
            <ng-container matColumnDef="maintenance_checked">
                <th mat-header-cell *matHeaderCellDef> Maintenance checked? </th>
                <td mat-cell *matCellDef="let element"> {{element.maintenance_check_text}} </td>
            </ng-container>

            <!-- last_software_version Column -->
            <ng-container matColumnDef="last_software_version">
                <th mat-header-cell *matHeaderCellDef> Last software version </th>
                <td mat-cell *matCellDef="let element"> {{element.last_software_version}} </td>
            </ng-container>

            <!-- remark Column -->
            <ng-container matColumnDef="remark">
                <th mat-header-cell *matHeaderCellDef> Remark </th>
                <td mat-cell *matCellDef="let element"> {{element.remark}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row (click)="selectTrailControlSystem(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

    </mat-card-content>
</mat-card>
